<style scoped>
    .line {
        height: 15px;
        width: 3px;
    }
</style>
<template>
    <div class="flex pl15 pt10 pb10 aic">
        <div class="line flex0 bg_main mr5"></div>
        <span class="ml5 mr5 flex0" :class="['fs'+size]">{{title}}</span>
        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "v-title",
    props: {
      title: {
        type: String,
        default: ""
      },
      size: {
        type: String,
        default: '18'
      }
    },
  }
</script>

